export const SHAQ_HOME_TAKEOVER_EXPERIMENT =
  'car-merch-ui-shaq-home-takeover-2026';
